import styled from "styled-components";
import media from "../../utils/media"

export const FootWrapper = styled.div`
min-height: 100vh;
background: #F6F9FD 0% 0% no-repeat padding-box;
`

export const FootColumn = styled.div`
display: flex;
padding-top: 120px;
padding-bottom: 20px;
`
export const CardGrid = styled.div`
display: grid;
grid-template-columns:  50% 50%;
${media.tablet`grid-template-columns:  auto`};
`


export const PorblemHeader = styled.div`
text-align: left;
font-Size: 36px;
font-weight: 900;
letter-spacing: -0.5px;
color: #091740;
margin-bottom: 20px;
margin-top: auto;
`

export const Card = styled.div`
display: flex;
flex-direction: column;
padding: 40px;
${media.tablet`padding: 20px`};
width: 100%;
min-height: 350px;
box-shadow: 32px 32px 48px #050E3514;
background: ${props => {
    switch (props.bg) {
      case "blue":
        return `#C5FFF0 0% 0% no-repeat padding-box`;
      default:
        return `#FFF 0% 0% no-repeat padding-box`;
    }
  }};
`
export const ProblemDescription = styled.p`
text-align: left;
font-Size: 18px;
font-weight: 300;
letter-spacing: -0.19px;
color: #091740;
margin-bottom: 60px;
`

export const GetStartedButton = styled.button`
background: #1E40C8 0% 0% no-repeat padding-box;
box-shadow: 0px 16px 48px #050E353D;
border-radius: 28px;
padding: 10px 9px 10px 9px;
border: none;
text-align: center;
letter-spacing: -0.2px;
color: #FFFFFF;
font-size: 16px;
width: 100%;
cursor: pointer;
`